module.exports = __webpack_public_path__ + "static/media/SimDeactivationBlue.4214539d.svg";